export const maskCpfCnpj = (text) => {
    let text2 = text.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');

    let final_num = '';
    if (text2.length <= 11) {
        for (let i = 0; i < text2.length && i < 11; i++) {
            if (!isNaN(text2[i])) {
                if (i == 3) {
                    final_num += '.' + text2[i];
                }
                else if (i == 6) {
                    final_num += '.' + text2[i];
                }
                else if (i == 9) {
                    final_num += '-' + text2[i];
                }
                else {
                    final_num += text2[i] + '';
                }
            }
        }
    }
    else {
        // 35.590.099/0001-03
        for (let i = 0; i < text2.length && i < 14; i++) {
            if (!isNaN(text2[i])) {
                if (i == 2) {
                    final_num += '.' + text2[i];
                }
                else if (i == 5) {
                    final_num += '.' + text2[i];
                }
                else if (i == 8) {
                    final_num += '/' + text2[i];
                }
                else if (i == 12) {
                    final_num += '-' + text2[i];
                }
                else {
                    final_num += text2[i] + '';
                }
            }
        }
    }

    return final_num;
    // this.setState({ cpf: final_num });
}

export const maskCnpj = (text) => {
    let text2 = text.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');
    let final_num = '';

    // 35.590.099/0001-03
    for (let i = 0; i < text2.length && i < 14; i++) {
        // if (Number.isInteger(text[i])) {
        if (!isNaN(text2[i])) {

            if (i == 2) {
                final_num += '.' + text2[i];
            }
            else if (i == 5) {
                final_num += '.' + text2[i];
            }
            else if (i == 8) {
                final_num += '/' + text2[i];
            }
            else if (i == 12) {
                final_num += '-' + text2[i];
            }
            else {
                final_num += text2[i] + '';
            }
        }
    }



    return final_num;
    // this.setState({ cpf: final_num });
}

export const maskNascimento = (text) => {
    let text2 = text.replace('/', '').replace('/', '');

    let final_num = '';

    for (let i = 0; i < text2.length && i < 8; i++) {
        // if (Number.isInteger(text[i])) {
        if (i == 2) {
            final_num += '/' + text2[i];
        }
        else if (i == 4) {
            final_num += '/' + text2[i];
        }
        else {
            final_num += text2[i] + '';
        }
        // }
    }
    return final_num;
}

export const maskTelefone = (text) => {
    let text2 = text.replace('(', '').replace(')', '').replace(' ', '').replace('-', '');
    let final_num = '';

    for (let i = 0; i < text2.length && i < 11; i++) {
        // if (Number.isInteger(text[i])) {
        if (!isNaN(text2[i])) {

            if (i == 0) {
                final_num += '(' + text2[i];
            }
            else if (i == 2) {
                final_num += ') ' + text2[i];
            }
            else if (i == 6 && text2.length <= 10) {

                final_num += '-' + text2[i];
            }
            else if (i == 7 && text2.length >= 11) {
                final_num += '-' + text2[i];
            }
            else {
                final_num += text2[i] + '';
            }
        }
    }
    return final_num;
}

export const maskRg = (text) => {
    let text2 = text.replace('.', '').replace('-', '').replace('.', '');

    let final_num = '';

    for (let i = 0; i < text2.length && i < 9; i++) {
        // if (Number.isInteger(text[i])) {
        if (i == 2) {
            final_num += '.' + text2[i];
        }
        else if (i == 5) {
            final_num += '.' + text2[i];
        }
        else if (i == 8) {
            final_num += '-' + text2[i];
        }
        else {
            final_num += text2[i] + '';
        }
        // }
    }
    return final_num;
    // this.setState({ cpf: final_num });
}

export const maskCep = (text) => {
    let text2 = text.replace('-', '');


    let final_num = '';

    for (let i = 0; i < text2.length && i < 8; i++) {
        // if (Number.isInteger(text[i])) {
        if (!isNaN(text2[i])) {

            if (i == 5) {
                final_num += '-' + text2[i];
            }
            else {
                final_num += text2[i] + '';
            }
        }
        // }
    }
    return final_num;
    // this.setState({ cep: final_num });

}

function reverseString(str) {
    // Step 1. Use the split() method to return a new array
    var splitString = str.split(""); // var splitString = "hello".split("");
    // ["h", "e", "l", "l", "o"]

    // Step 2. Use the reverse() method to reverse the new created array
    var reverseArray = splitString.reverse(); // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
    // ["o", "l", "l", "e", "h"]

    // Step 3. Use the join() method to join all elements of the array into a string
    var joinArray = reverseArray.join(""); // var joinArray = ["o", "l", "l", "e", "h"].join("");
    // "olleh"

    //Step 4. Return the reversed string
    return joinArray; // "olleh"
}

export const maskPrice = (text) => {

    text = text.replace(',', '');
    

    text = text.replace(/\./g, '');

    text = text.replace('R', '');
    text = text.replace('$', '');

    text = text.replace(' ', '');
    let text2 = text;
    text = text.replace('-', '');

    text = reverseString(text);
    let final_num = '';

    let minus = 4;
    for (let i = 0; i < text.length; i++) {
        if (isNaN(text[i])) {
            continue;
        }
        // if (Number.isInteger(text[i])) {
        if (i == 1 && i != text.length - 1) {
            final_num += text[i] + ',';
        }
        else if (i == minus && i != text.length - 1) {
            final_num += text[i] + '.';
            minus += 3;

        }
        else {
            final_num += text[i] + '';
        }
        // }
    }
    final_num = reverseString(final_num);
    if (text.length != 0)
        if (parseFloat(text2) >= 0) {
            final_num = 'R$ ' + final_num;
        }
        else {
            final_num = 'R$ -' + final_num;
        }
    // if(final_num.length==1){
    //     final_num+='R$ 00.0'+final_num;
    // }
    // else if(final_num==2){
    //     final_num+='R$ 00.'+final_num;
    // }
    // else{
    //     final_num+='R$ '+final_num;
    // }
    return final_num;
}

export const maskMoneyV2 = (value) => {
    if (!value) return "R$ 0,00";

    const numericValue = Number(value)
    const formattedValue = numericValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
    });

    return formattedValue;
};


export const maskNumber = (text2) => {


    let final_num = '';
    text2 = text2.replace(',', '')
    for (let i = 0; i < text2.length; i++) {
        if (!isNaN(text2[i]) || (text2[i] == '.' && !final_num.includes('.'))) {
            final_num += text2[i] + '';
        }
    }
    console.log(final_num)
    return final_num;
}

export const toNumber = (value) => {
    let final_num = '';
    value = value.replace(/\./g, '').trim().replace(',', '.')
    value = parseInt(value, 10)
    final_num = value;

    return final_num;
}

export const validateDecimals = (value) => {
    let t = '';
    value = value.replace('.', ',').trim()
    for (let i = 0; i < value.length; i++) {
        if (!isNaN(value[i]) || (value[i] == ',' && !t.includes(','))) {
            t += value[i] + '';
        }
    }
    // Ao chamar essa função, as casas decimais são limitadas a apenas 2 depois da vírgula. Ex: 10,9401 = 10,94
    let validatedValue = ((t.indexOf(",") >= 0) ? (t.substr(0, t.indexOf(",")) + t.substr(t.indexOf(","), 3)) : t)
    return (validatedValue);
}
function roundToTwo(num) {
    return +(Math.round(num + "e+2") + "e-2");
}

export const maskNumberBr = (text, peso = false) => {
    text = text.toString();
    if (peso == true) {
        console.log('Peso: ' + text)
    }
    let text2 = text;

    text = text.replace(/ /g, '');
    // text = text.replace(/\./g, '');
    // text = text.replace(/\,/g, '');
    // text = text.replace(/\-/g, '');
    if (text != '') {
        text = roundToTwo(parseFloat(text)).toString()
    }

    text2 = parseFloat(text);

    text = reverseString(text);
    let index_p = text.toString().indexOf('.');
    // text = parseFloat(text).toFixed(2);
    // text = text.replace(',', '');
    // text = text.replace(/\./g, '');

    // text = text.replace('R', '');
    // text = text.replace('$', '');


    let final_num = '';
    let minus = index_p + 3;
    // let minus = 4;
    for (let i = 0; i < text.length; i++) {

        if (i < index_p) {
            final_num += text[i] + '';
        }
        else if (i == index_p) {
            final_num = final_num + ',';
        }
        else if (i == minus && i != text.length - 1) {
            final_num += text[i] + '.';
            minus += 3;

        }
        else {
            final_num += text[i] + '';
        }

        // if (isNaN(text[i])) {
        //     continue;
        // }
        // // if (Number.isInteger(text[i])) {
        // if (i == 1 && i != text.length - 1) {
        //     final_num += text[i] + ',';
        // }
        // else if (i == minus && i != text.length - 1) {
        //     final_num += text[i] + '.';
        //     minus += 3;

        // }
        // else {
        //     final_num += text[i] + '';
        // }
        // }
    }
    final_num = reverseString(final_num);
    if (text.length != 0)
        if (parseFloat(text2) >= 0) {
            final_num = '' + final_num;
        }
        else {
            final_num = '-' + final_num;
        }
    // if(final_num.length==1){
    //     final_num+='R$ 00.0'+final_num;
    // }
    // else if(final_num==2){
    //     final_num+='R$ 00.'+final_num;
    // }
    // else{
    //     final_num+='R$ '+final_num;
    // }
    final_num = ((final_num.indexOf(",") >= 0) ? (final_num.substr(0, final_num.indexOf(",")) + final_num.substr(final_num.indexOf(","), 3)) : final_num)
    return final_num;
}

export const moneyMask = (value, around) => {
    let positive=true;
    if(value.includes('-')){
        positive=false;
    }
    try {
        value = value.replace('.', '').replace(',', '').replace(/\D/g, '')
    } catch { value = value }

    const options = { minimumFractionDigits: 2 };
    const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(value) / 100);

    if (around) return 'R$ ' + Math.ceil(value / 100).toFixed(2).replace('.', ',')
    return 'R$ '+(positive==false?'-':'') + (value / 100).toFixed(2).replace('.', ',')
}

export const maskNumber1 = (text2) => {


    let final_num = '';
    text2 = text2.replace(',', '')
    for (let i = 0; i < text2.length; i++) {
        if (!isNaN(text2[i]) && text2[i] != 0 || (text2[i] == '.' && !final_num.includes('.'))) {
            final_num += text2[i] + '';
        }
    }
    return final_num;
}

export const maskDouble = (text) => {


    let text2 = text.replace(',', '');
    text2 = text2.replace('.', '');


    text2 = text2.replace(' ', '');
    console.log(text2);

    text2 = parseFloat(text2).toString();
    console.log(text2);
    let final_num = '';

    if (text2.length == 1) {
        if (!isNaN(text2[0])) {
            final_num += '0,0' + text2[0];
        }
    }
    else if (text2.length == 2) {
        if (!isNaN(text2[0]) && !isNaN(text2[1])) {
            final_num += '0,' + text2[0] + text2[1];
        }
    }
    else {
        for (let i = 0; i < text2.length; i++) {
            if (!isNaN(text2[i])) {
                if (i == text2.length - 3) {
                    final_num += text2[i] + ',';
                }
                else {
                    final_num += text2[i] + '';
                }
            }
        }
    }

    return final_num;
}

export const maskPercent = (text2) => {


    let final_num = '';
    // text2 = text2.replace(',', '').replace('.', '')
    for (let i = 0; i < text2.length; i++) {
        if (!isNaN(text2[i]) || (text2[i] == '.' && !final_num.includes('.'))) {
            final_num += text2[i] + '';
        }
    }
    // final_num+='%';
    return final_num;
}


export const maskCpf = (text) => {
    let text2 = text.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');

    let final_num = '';
    for (let i = 0; i < text2.length && i < 11; i++) {
        if (!isNaN(text2[i])) {
            if (i == 3) {
                final_num += '.' + text2[i];
            }
            else if (i == 6) {
                final_num += '.' + text2[i];
            }
            else if (i == 9) {
                final_num += '-' + text2[i];
            }
            else {
                final_num += text2[i] + '';
            }
        }
    }


    return final_num;
    // this.setState({ cpf: final_num });
}

export const maskDate = (date_to_format) => {
    let temp_date = new Date(
        date_to_format
            .replace(/-/g, "/")
            .replace(/T.+/, "")
    );
    return temp_date.toLocaleDateString("pt-BR");
};

export const maskHour = (timestamp) => {
    const dateObj = new Date(timestamp);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const formatedHour = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    return formatedHour;
}